<template>
  <div id="app">
    <Loader></Loader> 
    <div class="main" v-if="!isNormalPage">
        <router-view></router-view>
    </div>
    <div class="main" v-if="isNormalPage">
      <section class="sidebar hidden-sm-down">
          <Sidebar></Sidebar> 
        </section>  
        <section class="main-content withsidebar">
        <div class="f-wrap">
           <transition name="fade">
          <router-view ></router-view>
           </transition>
          </div>
        </section>
         <!-- <mfs-header></mfs-header>
        <section class="container-fluid">
          <div class="f-wrap">
           <transition name="fade">
          <router-view ></router-view>
           </transition>
          </div>
       </section> -->
      </div>
  </div>
</template>

<script>
import mfsHeader from './components/common/mfs-header.vue'
import mfsFooter from './components/common/mfs-footer.vue'
import Sidebar from './components/common/sidebar'
import Loader from './components/common/loader'

export default {
  name: 'app',
  components: { mfsHeader, mfsFooter, Sidebar, Loader },
  data () {
    return {
    }
  },
  computed: {
    isNormalPage: function () {
      if (this.$route.path === '/' || this.$route.path === '/login' || this.$route.path === '/logout' || this.$route.path === '/signup') {
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss">

.f-wrap { position: relative;  z-index: 10; min-height:100vh;}
  // .fade-enter, .fade-leave-to{
  //   opacity:0;
  //   // min-height:200vh;
  // }
  // .fade-enter-to, .fade-leave{
  //   opacity:1;
  //   // min-height:200vh;
  // }
  // .fade-enter-active, .fade-leave-active{
  //   transition: all 1s;
  // }
    .fade-enter, .fade-leave-to{
    opacity:0; transform: translateY(100%);
    // min-height:200vh;
  }
  .fade-enter-to, .fade-leave{
    opacity:1; transform: translateY(50%); 
    // min-height:200vh;
  }
  .fade-enter-active, .fade-leave-active{
    transition: all 0.25s;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue